import type { FC } from "react";

import {
  DRAWER_HEADER_CLASS,
  type TDrawerHeaderProps,
} from "@/ui/components/overlay/Drawer/Drawer.config";
import { cn } from "@/ui/lib/utils";

export const DrawerHeader: FC<TDrawerHeaderProps> = (
  {
    className,
    ...props
  },
) => (
  <div
    data-component="DrawerHeader"
    className={cn(
      DRAWER_HEADER_CLASS,
      className,
    )}
    {...props}
  />
);

DrawerHeader.displayName = "DrawerHeader";
